module.exports = __webpack_public_path__ + "static/img/wise-map-mobile.4672195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wise-map-mobile.png
// module id = 1236
// module chunks = 65